export enum McaTimeSeriesTagCodeEnum {
  CURRENT = "current",
  PERCENT_UNBALANCE = "percent_unblance",
  I0 = "I0",
  SPEED = "Speed",
  THDi = "THDi",
  ROTOR_BAR_CRACK = "Rotor bar crack",
  ECCENTRIC_AIR_GAP = "Eccentric Air Gap",
  MECHANICAL_FAILURE = "Mechanical Failure",
  STATOR_SHORT_TURN = "Stator Short Turn",
  BEARING = "Bearing",
}
